import { createAction } from '@reduxjs/toolkit';
import { EvaluatedQuestionState } from './model';

enum EvaluatedQuestionAction {
  setListFilters = '@evaluatedQuestion/setListFilters',
  setSelectedFilters = '@evaluatedQuestion/setSelectedFilters',
  setMaxLengthFilters = '@evaluatedQuestion/setMaxLengthFilters',
  setOldSelectedFilters = '@evaluatedQuestion/setOldSelectedFilters',
  resetState = '@evaluatedQuestion/resetState',
}

const setListFilters = createAction<EvaluatedQuestionState['listFilters']>(
  EvaluatedQuestionAction.setListFilters
);
const setSelectedFilters = createAction<EvaluatedQuestionState['selectedFilters']>(
  EvaluatedQuestionAction.setSelectedFilters
);
const setMaxLengthFilters = createAction<EvaluatedQuestionState['maxLengthFilters']>(
  EvaluatedQuestionAction.setMaxLengthFilters
);
const setOldSelectedFilters = createAction<EvaluatedQuestionState['oldSelectedFilters']>(
  EvaluatedQuestionAction.setOldSelectedFilters
);
const resetState = createAction(EvaluatedQuestionAction.resetState);

export const evaluatedQuestionAction = {
  setListFilters,
  setSelectedFilters,
  setMaxLengthFilters,
  resetState,
  setOldSelectedFilters,
};
